import React, { useEffect, useRef, useState } from 'react';
import { TiThMenu } from 'react-icons/ti';
import { useNavigate } from 'react-router-dom';
import { useUserContext } from '../../user/context/UserContext.tsx';
import { ROUTE_NAME_OPTIONS } from '../../utils/constants.ts';
import { isLogged } from '../../utils/utils.ts';
import Button from '../button/Button.tsx';
import {
  FaSignOutAlt,
  FaShoppingCart,
  FaList,
  FaBox,
  FaUser,
  FaDollarSign,
  FaBoxes,
} from 'react-icons/fa';

import './dropdown.scss';
import {
  initialShoppingCart,
  useProductContext,
} from '../../product/context/ProductContext.tsx';

interface DropdownProps {
  title?: string;
  items: Routes[];
}

interface Routes {
  label: string;
  routeName: string;
}

const Dropdown: React.FC<DropdownProps> = ({ title, items }) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  const navigate = useNavigate();

  const { logout } = useUserContext();
  const { setShoppingCart } = useProductContext();

  const toggleDropdown = () => {
    setIsOpen((prev) => !prev);
  };

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node)
      ) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const handleNavigate = (routeName: string) => {
    navigate(`/${routeName}`);
  };

  const handleLogout = () => {
    if (isLogged()) {
      logout();
      setIsOpen(false);
      setShoppingCart(initialShoppingCart);
    }
    navigate(`/`);
  };

  const handleLogin = () => {
    navigate(`/${ROUTE_NAME_OPTIONS.LOGIN}`);
  };

  const getIcon = (label: string) => {
    switch (label) {
      case 'Listado productos':
        return <FaBoxes className="icon-style" />;
      case 'Ver carrito':
        return <FaShoppingCart className="icon-style" />;
      case 'Lista de Precios':
        return <FaDollarSign className="icon-style" />;
      case 'Crear Producto':
        return <FaBox className="icon-style" />;
      case 'Mi Información':
        return <FaUser className="icon-style" />;
      case 'Mis pedidos':
        return <FaList className="icon-style" />;
      default:
        return null;
    }
  };

  return (
    <div className="dropdown" ref={dropdownRef}>
      <Button className="button margin-responsive" onClick={toggleDropdown}>
        <TiThMenu size={20} />
      </Button>
      {isOpen && (
        <div className="dropdown-menu">
          {items.map((item, index) => (
            <div
              key={index}
              onClick={() => handleNavigate(item.routeName)}
              className="dropdown-item"
            >
              <div className="dropdown-icon-label">
                {getIcon(item.label)}
                <span>{item.label}</span>
              </div>
            </div>
          ))}

          <div
            onClick={() => (isLogged() ? handleLogout() : handleLogin())}
            className="dropdown-item"
          >
            <div className="dropdown-icon-label">
              <FaSignOutAlt className="icon-style" />
              <span>{isLogged() ? 'Salir' : 'Ingresa'}</span>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Dropdown;
